module.exports = __webpack_public_path__ + "img/illust_01_focus2.7cef6873.png";